<template>
    <div class="option-content full-width">
        <div class="packet-row packet-column packet-checkbox packet-line mb-1 pb-1" style="border-bottom: none; padding-top: 0px;">
            <div class="option-content full-width option-upload-content carrierInfo_invoiceDeliveryType_input">
                <label for="get-print" class="custom-radio-wrap">
                    {{ $helper.trans('Printed_label') }}
                    <input type="radio" v-model="$store.state.importInformation.labelType" value="print" id="get-print">
                    <span class="checkmark"></span>
                </label>                                       
                <label for="get-electronic" class="custom-radio-wrap">
                    {{ $helper.trans('Electronic_label') }}
                    <input type="radio" v-model="$store.state.importInformation.labelType" value="electronic" id="get-electronic">
                    <span class="checkmark"></span>
                </label>
            </div>
        </div>
        <p class="font-weight-bold text-danger" v-html="$helper.trans('Attention_import_shipments_senders_must_contact_to_ups')"></p>

        <label class="strong-label" v-if="$store.state.importInformation.labelType === 'electronic'">{{ $helper.trans('Label_presenting_information') }}</label>

        <div class="mb-4" v-if="$store.state.importInformation.labelType === 'electronic'">
            <input type="text" v-model="$store.state.importInformation.email" :placeholder="'* ' + $helper.trans('Email')" class="input-big w-50 mt-2 importInformation_email_input" />
        </div>      

        <div class="packet-row packet-column packet-textarea" v-if="$store.state.importInformation.labelType === 'electronic'">
            <label class="strong-label">{{ $helper.trans('Message_for_recipient') }}</label>
            <textarea class="importInformation_notes_input" v-model="$store.state.importInformation.notes"></textarea>
        </div>

        <div class="packet-row packet-column packet-option mb-2" v-if="$store.state.importInformation.labelType === 'electronic'">
            <div class="option-content">
                <label for="op-20" class="custom-checkbox-wrap mb-1">
                    {{ $helper.trans('Notify_when_problem_delivery') }}
                    <input type="checkbox" id="op-20" :value="1" v-model="$store.state.importInformation.sendNotification"> 
                    <span class="checkmark"></span>
                </label>
            </div>
        </div>

        <div v-if="($store.state.importInformation.sendNotification && $store.state.importInformation.labelType === 'electronic')">
            <input type="text" v-model="$store.state.importInformation.notificationEmail" :placeholder="$helper.trans('Email')" class="input-big w-50 mt-2 importInformation_notificationEmail_input" />
        </div>
    </div>
</template>

<script>
import store from "../../../store";
export default {
    store,
}
</script>
